import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { bool, oneOf } from 'prop-types'

const StyledActionButton = styled.button`
	${({ theme, variant }) => theme.buttons[variant]};
	${({ active, theme }) =>
		!active
			? css`
					background-color: ${theme.colors.gray[300]};
					color: ${theme.colors.dimGrey};
					&:hover:not([disabled]) {
						background-color: ${theme.colors.gray[300]};
						color: ${theme.colors.dimGrey};
					}
			  `
			: null};
`

export const ActionButton = ({ active = true, children, variant = 'default', ...props }) => (
	<StyledActionButton variant={variant} active={active} {...props}>
		{children}
	</StyledActionButton>
)

ActionButton.propTypes = {
	active: bool,
	variant: oneOf(['default', 'secondary', 'transparent', 'link', 'small', 'smallSecondary']),
}
